import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import queryString from 'query-string'
import Cookies from 'js-cookie'
import {
  PREFIX_SOPERATION_API,
  PREFIX_SCC_API,
  PREFIX_SPROMOTION_API,
  PREFIX_KS_SORDER
} from '@/service'
const api = {
  // home: `${utils.hostname('cms')}/publish/998/dingzhi.json`,
  index: `${utils.hostname('cms')}/publish/999/Restructure_index.json`,
  // index: `${utils.hostname('cms')}/publish/999/index_new.json`
  consultant: PREFIX_SCC_API + 'fchild/worker/queryNearByWorkerList.do',
  nearbyActivity: '//ias.cekid.com/ias-web/aic/queryNearActList.do',
  getAdvertisements: PREFIX_SOPERATION_API + 'ads/queryAdvertisements.do',
  queryQYWorkerOrderCount: PREFIX_KS_SORDER + 'queryQYWorkerOrderCount.do', // 育儿服务订单列表页
  getEmpRefInfo:
    '//subscriber.cekid.com/subscriber-web/empRef/getEmpRefInfo.do', // 根据手机号码或uid查询是否是孩子王员工
  getPromTips: PREFIX_SPROMOTION_API + 'promotion/getPromTips.do' // 团购秒杀
}

export default {
  async getIndexPageSettings({ commit }) {
    try {
      const settings = await fetch(api.index)
      const settingsJson = await settings.json()
      return settingsJson.data || {}
    } catch (e) {
      console.log(e)
    }
  },
  async queryQYWorkerOrderCount({ commit }, params) {
    try {
      const query = queryString.stringify(params)
      const res = await fetch(`${api.queryQYWorkerOrderCount}?${query}`)
      const json = await res.json()
      return json
    } catch (e) {
      console.log(e)
    }
  },
  async getEmpRefInfo({ commit }, params) {
    try {
      const query = queryString.stringify(params)
      const res = await fetch(`${api.getEmpRefInfo}?${query}`, {
        credentials: 'include'
      })
      // const res = await fetch(api.getEmpRefInfo, {
      //     headers: {
      //         'Content-Type': 'application/x-www-form-urlencoded'
      //     },
      //     method: 'POST',
      //     body: query,
      //     credentials: 'include'
      // })
      const json = await res.json()
      return json
    } catch (e) {
      console.log(e)
    }
  },
  async getAdvertisements({ commit }, params) {
    try {
      const query = queryString.stringify(params)
      const res = await fetch(`${api.getAdvertisements}?${query}`)
      const json = await res.json()
      return json
    } catch (e) {
      console.log(e)
    }
  },
  async getHomeArticleList({ commit }, { ids }) {
    try {
      const query = queryString.stringify({
        ids
      })
      const res = await fetch(
        `//apiart.cekid.com/api/v1/article/piliang?${query}`
      )
      const json = await res.json()
      return json
    } catch (e) {
      console.log(e)
    }
  },
  async getExclusiveConsultantList({ commit }, { cityId, lat = '', lng = '' }) {
    try {
      const params = `?uid=${
        Cookies.get('uid') || ''
      }&cityId=${cityId}&lat=${lat}&lng=${lng}`
      const res = await fetch(`${api.consultant}${params}`)
      const json = (await res.json()) || {}
      return json.data
    } catch (e) {
      console.log(e)
    }
  },
  async getNearbyActivity({ commit }, { param }) {
    try {
      const res = await fetch(
        `${api.nearbyActivity}?param=${encodeURIComponent(
          JSON.stringify(param)
        )}`
      )
      const json = (await res.json()) || []
      return json.data
    } catch (e) {
      console.log(e)
    }
  },
  async getPromTips({ commit }, payload) {
    try {
      const query = queryString.stringify(payload)
      const res = await fetch(`${api.getPromTips}?${query}`)
      const json = (await res.json()) || []
      return json.data || {}
    } catch (e) {
      console.log(e)
      return {}
    }
  }
}
